import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import Vuelidate from 'vuelidate'
import router from './router'
import store from './store'
import './registerServiceWorker'
import firebase from "firebase/app"
// require("firebase/auth");
// require("firebase/database");
Vue.use(Vuelidate)

Vue.config.productionTip = false

firebase.initializeApp({
  apiKey: "AIzaSyBoZZAoQffootYMdHI7zw5qcbhwjJQkats",
  authDomain: "papaya-agency.firebaseapp.com",
  projectId: "papaya-agency",
  storageBucket: "papaya-agency.appspot.com",
  messagingSenderId: "1028066029556",
  appId: "1:1028066029556:web:89d4d00e88ad82b26413a1",
  measurementId: "G-PBJ6WJQ8CT"
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
